import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-brand-borderColor"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="brand-logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="h-10 w-10 rounded-full bg-brand-primary text-brand-base flex items-center justify-center font-display font-bold text-lg group-hover:bg-brand-primaryHover transition-colors">
            SK
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-display text-base sm:text-lg text-brand-primary tracking-tight">
              SK-ANNU
            </span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-brand-textMuted">
              Exports LLP
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-brand-primary/80 hover:text-brand-primary relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-px after:bg-brand-accent hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-order-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-brand-base px-5 py-2.5 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5"
          >
            <MessageCircle size={16} strokeWidth={1.8} />
            Order on WhatsApp
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-brand-primary"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-brand-borderColor">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-brand-primary text-lg font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-order-btn"
              className="inline-flex items-center gap-2 rounded-full bg-brand-primary text-brand-base px-5 py-3 text-sm font-medium w-fit"
            >
              <MessageCircle size={16} /> Order on WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
